import { render, staticRenderFns } from "./OpenDispute.vue?vue&type=template&id=f66fb2dc&scoped=true&"
import script from "./OpenDispute.vue?vue&type=script&lang=js&"
export * from "./OpenDispute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66fb2dc",
  null
  
)

export default component.exports